module.exports = __webpack_public_path__ + "img/Element_extraction-5.008f32a2.jpg";